import QCXFormStepWizard from '../../../../../../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectManyCamposAdicionaisTable from './SelectManyCamposAdicionaisTable';

export default function SelectManyCamposAdicionaisTab({
  list = [],
  isConsult,
  title,
  filterProp,
  filterPropGetter,
  columns,
  handleSubmit,
  handleChange,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <QCXSelectManyCamposAdicionaisTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          filterPropGetter={filterPropGetter}
          selected={list}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
